<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra">
    <div class="row  ps-3">
      <div class="col pt-3 ">
        <p> <span class="fw-bold">Penyenggaraan</span> - Daftar / Kemaskini </p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila masukkan No. Pengenalan</p>
      </div>
    </div>
    <div class="row pb-5">
      <div class="col-2 mx-5">
        <input type="text" class="form-control border-0 shadow" placeholder="No. Pengenalan" id="IDNoInput" [(ngModel)]="IDNoInput" [ngModelOptions]="{standalone: true}" placeholder="No. Pengenalan">
      </div>
      <div class="col-8">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Hantar(IDNoInput,FirmIDView)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" (click)="Semula()">Semula</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" (click)="GotoDetailPage()">Daftar Baharu</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Tax Agent Table -->
    <div class="mx-3" *ngIf="TaxAgentSearchStatus">
      <div class="pt-5">
        <p>Senarai Ejen Cukai</p>
        <!-- <input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">     -->
      </div>
      <div class="example-table-container">

        <table mat-table [dataSource]="taxagentDataSource" class="w-100 shadow">
          <ng-container matColumnDef="name">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.taxAgentName}}</td>
          </ng-container>

          <ng-container matColumnDef="idno">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Pengenalan</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.icNo}}</td>
          </ng-container>
          <ng-container matColumnDef="licenseno">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Kelulusan</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.licenseNo}}</td>
          </ng-container>
          <ng-container matColumnDef="certstart">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tempoh Kelulusan Mula</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.licenseStart}}</td>
          </ng-container>
          <ng-container matColumnDef="certend">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tempoh Kelulusan Tamat</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.licenseEnd}}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Status Ejen</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.status ? 'Aktif' : 'Tidak Aktif'}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
            <td mat-cell *matCellDef="let res">

              <div class="btn-toolbar d-flex justify-content-center">
                <div *ngIf="!IsAgentStatus" class="me-2">
                  <button type="button" class="btn button-white-sm border-0 shadow rounded-2" (click)="ViewUpdateTaxAgent(res.staffID,res.taxAgentID,res.icNo,res.taxAgentName,res.licenseNo,res.licenseStart,res.licenseEnd,res.myCukaiEmail,res.taxAgentPhoneNo,res.firmUserEmail,res.status)" data-bs-toggle="modal" data-bs-target="#agentUpdateModal" role="button">Kemaskini</button>
                </div>
                <div *ngIf="!IsAgentStatus" class="me-2">
                  <button type="button" class="btn button-white-sm border-0 shadow rounded-2" data-bs-toggle="modal" data-bs-target="#deleteAgentModal" (click)="TaxAgentDeleteView(res.staffID,res.taxAgentID,res.icNo,res.taxAgentName)" role="button">Hapus</button>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedTaxAgentColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let test;columns:displayedTaxAgentColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="9">Tiada Rekod</td>
          </tr>
        </table>
        <mat-paginator class="mat-evelation-z8" (page)="paginatorTaxAgentEvent($event,FirmIDView,IDNoView)" [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5,10,15]" [length]="TaxAgentRecordCount">
        </mat-paginator>
      </div>
    </div>

    <!-- Other Than Tax Agent Table -->
    <div class="mx-3" *ngIf="NotTaxAgentSearchStatus">
      <div class="pt-5">
        <p>Senarai Selain Ejen Cukai</p>
        <!-- <input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">     -->
      </div>
      <div class="example-table-container">

        <table mat-table [dataSource]="staffDataSource" class="w-100 shadow">
          <ng-container matColumnDef="name">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Nama</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.staffName}}</td>
          </ng-container>

          <ng-container matColumnDef="idno">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>No. Pengenalan</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.icNo}}</td>
          </ng-container>
          <ng-container matColumnDef="role">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Peranan</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.role}}</td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Email</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.firmUserEmail}}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Status Pengguna</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.status ? 'Aktif' : 'Tidak Aktif'}}</td>
          </ng-container>
          <ng-container matColumnDef="datecreated">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tarikh Daftar</th>
            <td class="text-center" mat-cell *matCellDef="let res">{{res.dateCreated}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th class="text-center primary-colour" mat-header-cell *matHeaderCellDef>Tindakan</th>
            <td mat-cell *matCellDef="let res">
              <div class="btn-toolbar d-flex justify-content-center">
                <div *ngIf="!IsAgentStatus" class="me-2">
                  <button type="button" class="btn button-white-sm border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#staffUpdateModal" (click)="ViewUpdateStaff(res.staffID,res.staffName,res.icNo,res.role,res.firmUserEmail,res.status)">Kemaskini</button>
                </div>
                <div *ngIf="!IsAgentStatus" class="me-2">
                  <button type="button" class="btn button-white-sm border-0 shadow rounded-2" role="button" data-bs-toggle="modal" data-bs-target="#deleteModal" (click)="StaffDeleteView(res.staffID,res.icNo,res.staffName,res.role)">Hapus</button>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedStaffColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let test;columns:displayedStaffColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" colspan="7">Tiada Rekod</td>
          </tr>
        </table>
        <mat-paginator class="mat-evelation-z8" (page)="paginatorStaffEvent($event,FirmIDView,IDNoView)" [pageIndex]="0" [pageSize]="5" [pageSizeOptions]="[5,10,15]" [length]="StaffRecordCount">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>


<!-- Agent Update Modal -->
<div class="modal fade" id="agentUpdateModal" tabindex="-1" aria-labelledby="agentUpdateModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" #agentUpdateCloseButton data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Kemaskini</p>
          </div>
        </div>

        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <p class="text-muted fst-italic">Sila masukkan butiran bagi tindakan kemaskini</p>

            <div class="row py-2">
              <div class="col-2">
                <p>Nama Ejen</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col">
                <p class="fw-bold">{{TaxAgentNameView}}</p>
              </div>

              <div class="col-2">
                <p>No. Pengenalan Ejen</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col">
                <p class="fw-bold">{{TaxAgentIDNoView}}</p>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-2">
                <p>Tempoh Mula Lesen</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col">
                <p class="fw-bold">{{TaxAgentCertStartView}}</p>
              </div>

              <div class="col-2">
                <p>Tempoh Tamat Lesen</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col">
                <p class="fw-bold">{{TaxAgentCertEndView}}</p>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-2">
                <p>No. Kelulusan Ejen</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col-4">
                <p class="fw-bold">{{TaxAgentApprovalNo}}</p>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-2">
                <p>MyCukai e-mel</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col-3">
                <p class="fw-bold">{{TaxAgentEmail}}</p>
                <!--<input type="text" class="form-control border-0 shadow" [(ngModel)]="TaxAgentEmail" [ngModelOptions]="{standalone: true}" placeholder="Emel">-->
              </div>
              <div class="col-2">
                <p>e-mel Ejen Cukai</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col-3">
                <input type="text" class="form-control border-0 shadow" [(ngModel)]="TaxAgentFirmUserEmailInput" [ngModelOptions]="{standalone: true}" placeholder="Emel Firma">
              </div>
            </div>
            <div class="row py-2">
              <div class="col-2">
                <p>No. Telefon Ejen</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col-3">
                <p class="fw-bold">{{TaxAgentPhoneNoView}}</p>
                <!--<input type="text" class="form-control border-0 shadow" [(ngModel)]="TaxAgentEmail" [ngModelOptions]="{standalone: true}" placeholder="Emel">-->
              </div>
              <div class="col-2">
                <p>Status Ejen</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col-3">
                <select class="form-select border-0 shadow" aria-label="Role" [(ngModel)]="TaxAgentFirmUserStatus" [ngModelOptions]="{standalone: true}" (change)="onChange()">
                  <option value="true">Aktif</option>
                  <option value="false">Tidak Aktif</option>
                </select>
              </div>
            </div>
          </div>
          <div class="btn-toolbar d-flex justify-content-center pb-5 pt-5">
            <div class="me-2">
              <button type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="UpdateTaxAgent(TaxAgentStaffIDView,FirmIDView,TaxAgentFirmUserEmailInput,TaxAgentFirmUserStatus)">Kemaskini</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Staff Update Modal -->
<div class="modal fade" id="staffUpdateModal" tabindex="-1" aria-labelledby="staffUpdateModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" #staffUpdateCloseButton data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>

        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Kemaskini</p>
          </div>
        </div>

        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <p class="text-muted fst-italic">Sila masukkan Nama, No. Pengenalan dan Kumpulan Pengguna</p>

            <div class="row py-2">
              <div class="col-2">
                <p>Nama Staf</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col">
                <p class="fw-bold">{{StaffNameView}}</p>
              </div>
              <div class="col-2">
                <p>No. Pengenalan Staf</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col">
                <p class="fw-bold">{{StaffIDNoView}}</p>
              </div>
            </div>


            <div class="row py-2">
              <div class="col-2">
                <p>Emel Firma</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col">
                <input type="text" class="form-control border-0 shadow" [(ngModel)]="StaffFirmUserEmailInput" [ngModelOptions]="{standalone: true}" placeholder="Emel Firma">
              </div>
              <div class="col-2">
                <p>Peranan Pengguna</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div *ngIf="StaffRoleView === '0201'" class="col-3">
                <p class="fw-bold">Pentadbir</p>
              </div>
              <div *ngIf="StaffRoleView !== '0201'" class="col-3">
                <select class="form-select border-0 shadow" aria-label="Role" [(ngModel)]="StaffRoleView" [ngModelOptions]="{standalone: true}" (change)="onChange()">
                  <option value="0202">Penyelia</option>
                  <option value="0203">Staf</option>
                </select>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-2">
                <p>Status Pengguna</p>
              </div>
              <div class="col-1">
                :
              </div>
              <div class="col-3">
                <select class="form-select border-0 shadow" aria-label="Role" [(ngModel)]="StaffFirmUserStatus" [ngModelOptions]="{standalone: true}" (change)="onChange()">
                  <option value="true">Aktif</option>
                  <option value="false">Tidak Aktif</option>
                </select>
              </div>
            </div>
            <div *ngIf="UpdateRole" class="pt-2">
              <p class="fs-6" style="color: #eb4034;">*Penukaran peranan akan menghapuskan hubungan sedia ada</p>
            </div>
          </div>
          <div class="btn-toolbar d-flex justify-content-center pb-5 pt-5">
            <div class="me-2">
              <button type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="UpdateStaff(StaffIDView,FirmIDView,StaffRoleView,StaffFirmUserEmailInput,StaffFirmUserStatus)">Kemaskini</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Hapus Staff Modal -->
<div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/dustbin-yellow-circle.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk hapus rekod ini?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn button-white-sm shadow bg-white" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Tidak</button>
            <button class="btn button-white-sm shadow mx-3 bg-white" (click)="StaffDeleteSubmit(StaffIDView,'',StaffRoleView)" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Ya</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Hapus Agent Modal -->
<div class="modal fade" id="deleteAgentModal" tabindex="-1" aria-labelledby="deleteAgentModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center">
          <img src="./assets/icons/dustbin-yellow-circle.svg" height="90" width="90" alt="..." />
        </div>
        <p class="fw-bold text-center">Adakah anda pasti untuk hapus rekod ini?</p>
        <div class="d-flex justify-content-center align-items-center pb-3 pt-3">
          <div class="d-block">
            <button class="btn button-white-sm shadow bg-white" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Tidak</button>
            <button class="btn button-white-sm shadow mx-3 bg-white" (click)="AgentDeleteSubmit(StaffIDView,TaxAgentIDView,'0204')" style="height: 35px; width: 102px" type="button" data-bs-dismiss="modal">Ya</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
